import { findWhere } from 'underscore';
import Api from './api';

/**
 * @deprecated
 * Вместо getInitialProps используем хук `useTableHashData`
 */
const getQrHubProps = async ({ req, query }) => {
  const { tableHash } = query;
  const api = new Api({ domain: req ? req.headers.host : null });
  const settings = await api.getQrHubSettings(tableHash);

  return {
    settings,
    query,
  };
};

/**
 * @deprecated
 * Вместо getInitialProps используем хук `useTableHashData`
 */
export const getQrHubOrderProps = async ({ res, req, query }) => {
  const { orderId, tableHash } = query;

  const api = new Api({ domain: req ? req.headers.host : null });

  try {
    const settings = await api.getQrHubSettings(tableHash);

    const { transactions } = await api.getTableData(tableHash);
    const transaction = findWhere(transactions, { transaction_id: orderId });

    if (transactions?.length === 0 || !transaction) {
      if (res) {
        res.writeHead(301, { Location: `/hub/${tableHash}/` });
        res.end();
      }
    }

    return {
      settings,
      query,
    };
  } catch (error) {
    return error;
  }
};

export default getQrHubProps;
